import React, { FC } from 'react';
import ErrorPage from './ErrorPage';

const ServerError: FC = () => <ErrorPage errorCode={500} />;
export default ServerError;